export class BannerParamId {

    constructor(private _value: string) {}

    get value(): string {
        return this._value;
    }

}
